import {
    postRequest,
    getRequest
} from "./request";
// token验证
export const checkToken = data => postRequest("/api/user/checkToken", data, false);
// 获取Toke
export const getToken = data => postRequest("/api/common/getToken", data, false);
export const wechatLogin = data => postRequest("/api/wechat/login", data, false);
// 获取token状态
export const tokenStatus = data => getRequest("/api/common/tokenStatus", data);
// 获取用户详情
export const memberInfo = data => postRequest("/api/user/detail", data,true);
// 获取微信配置
export const getWxConfig = data => getRequest("/api/wechat/config", data);
// 获取分享配置
export const configShare = data => getRequest("/api/config/index", data);
// 推荐位
// export const getPath = data => getRequest("/api/position.content/getPath", data);
export const positionList = data => getRequest("/api/position.content/lists", data);
export const positionDetail = data => getRequest("/api/position.content/detail", data);
// 推荐位规则
// export const getContent = data => getRequest("/api/position.content/getContent", data);
// 推荐位规则
// export const getIndexBanner = data => getRequest("/api/position.content/getIndexBanner", data);
// 上传图片
export const commonUpload = data => postRequest("/api/upload/image", data,false);
// 日期列表
export const appointmentDate = data => postRequest("/api/appointment.date/all", data,false);
export const appointmentOptions = data => postRequest("/api/platform.cultural_center.appointment/options", data,false);
export const appointmentDateOp = data => postRequest("/api/platform.cultural_center.appointment/date", data,false);
// 日期列表详情
export const dateDetail = data => postRequest("/api/appointment.date/detail", data,false);
// 预约
export const appointmentAdd = data => postRequest("/api/platform.cultural_center.appointment/add", data,true);
export const appointmentCancel = data => postRequest("/api/platform.cultural_center.appointment/cancel", data,true);
// 预约列表
export const appointmentQuery = data => postRequest("/api/platform.cultural_center.appointment/lists", data,true);
// 预约详情
export const appointmentDetail = data => postRequest("/api/platform.cultural_center.appointment/detail", data,true);
export const culturalDetail = data => postRequest("/api/platform.cultural_center/detail", data,true);
